import React from "react";

const servicios = [
  "Plomeros", "Electricistas", "Gasistas", "Persianas (service y colocación)",
  "Cerrajeros", "Destapaciones", "Aire acondicionado (service y colocación)",
  "Alarmas", "Albañiles", "Bombas de agua (service y colocación)", "Burletes",
  "Carpinteros", "Computación", "Fletes y Mudanzas", "Fumigadores",
  "Herreros", "Jardineros", "Alfombras y Tapizados, limpieza",
  "tanques de agua, limpieza", "Toldos", "limpieza", "Lustradores de muebles",
  "Mecánicos automotores", "Mensajería", "Microondas, TV y video.",
  "Multirubro", "Parquetistas", "Pintores de interior", "Telefonía (service)",
  "Tender", "Toldos (service y colocación)", "Valvulistas"
];

const ServiciosMarquee = () => {
  return (
    <div className="overflow-hidden whitespace-nowrap bg-white border-y border-gray-100 py-4">
      <div className="animate-marquee inline-block">
        {servicios.concat(servicios).map((servicio, index) => (
          <span key={index} className="font-clash mx-4 text-sm md:text-base text-secondary font-semibold uppercase">
            {servicio}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ServiciosMarquee;
